
/* le consentement contextuel axeptio - youtube */
(_axcb = window._axcb || []).push(function(sdk) {
  sdk.on('cookies:complete', function(choices){
    document
      .querySelectorAll('[data-hide-on-vendor-consent]')
      .forEach(el => {
        const vendor = el.getAttribute('data-hide-on-vendor-consent');

        el.style.display = choices[vendor] ? 'none' : 'inherit';
      });

    /* custom GM */
    document
      .querySelectorAll('[data-show-on-vendor-consent]')
      .forEach(el => {
        const vendor = el.getAttribute('data-show-on-vendor-consent');

        el.style.display = choices[vendor] ? 'inherit' : 'none';
      });

    /* iframe */
    document
      .querySelectorAll('[data-requires-vendor-consent]')
      .forEach(el => {
        const vendor = el.getAttribute('data-requires-vendor-consent');
        if (choices[vendor]) {

          el.setAttribute('src', el.getAttribute('data-src'));
          el.style.display = 'block';

          var btn = el.parentElement.querySelectorAll('.axeptio-youtube')[0];
          if (typeof btn !== 'undefined') {
            btn.style.display = 'none';
          }
        } else {
          var btn = el.parentElement.querySelectorAll('.axeptio-youtube')[0];

          if (typeof btn === 'undefined') {
            el.style.display = 'none';
            var btn = document.createElement("button");
            btn.setAttribute('onClick',"window.axeptioSDK.requestConsent('"+vendor+"')");
            btn.classList.add('axeptio-youtube');
            btn.innerText += "Pour voir cette vidéo je dois accepter les cookies "+vendor+"";
            el.parentElement.appendChild(btn);
          }
        }
      });
  });
});
